/**
 * EL CONFIRMAR DE LA CONCILIACION DE BANCO GUARDA (BAN-T3, ronda de calidad #20837).
 *
 * El match-review de #/auditoria > Conciliacion banco confirmaba contra n8n /webhook/conciliacion-banco/apply, un
 * webhook que nunca existio (medido el 1-oct: 404 "not registered"; el de compras, en cambio, si responde). Josse
 * confirmaba y no quedaba nada: los 292 movimientos siguen 'pending'. La API ya tenia la puerta (CB-T4):
 * POST /api/v1/auditoria/bank-movements/status {businessId, movimientos:[{bankMovementId, status}]}.
 *
 * Puro sobre el cliente que recibe. Lo mide scripts/check-cruce-banco.mjs.
 *
 * @module application/conciliacion/cruceBanco
 */

/** Las aprobaciones MATCH del match-review -> movimientos 'matched' (uno por movimiento, sin repetir). */
export function movimientosCruzados(aprobaciones) {
  const vistos = new Set();
  const salida = [];
  for (const a of Array.isArray(aprobaciones) ? aprobaciones : []) {
    const id = typeof a?.item_id === 'string' ? a.item_id.trim() : '';
    if (a?.accion !== 'MATCH' || !id || vistos.has(id)) continue;
    vistos.add(id);
    salida.push({ bankMovementId: id, status: 'matched' });
  }
  return salida;
}

/**
 * El `confirmar` que recibe match-review: guarda por la API y devuelve {ok, body} o {ok:false, error}.
 * @param {{confirmBankStatus: function(string, Array): Promise<{ok:boolean, data?:object, error?:string}>}} cliente
 * @param {() => string} negocio  el negocio seleccionado AL confirmar (no al abrir)
 */
export function confirmadorDeCruce(cliente, negocio) {
  return async ({ aprobaciones }) => {
    const movimientos = movimientosCruzados(aprobaciones);
    if (!movimientos.length) return { ok: false, error: 'No hay movimientos cruzados para guardar.' };
    const res = await cliente.confirmBankStatus(negocio(), movimientos);
    if (!res?.ok) return { ok: false, error: res?.error || 'No se pudo guardar el cruce.' };
    return { ok: true, body: { aprobados_match: movimientos.length, actualizados: res.data?.actualizados ?? null } };
  };
}
